<template>
  <div data-automation="apiStepTwo">
    <div class="x-border-50 x-margin-b">
      <my-head-title :title="$t('HT.apiStepTwo.title')"></my-head-title>
      <div class="x-flex-justify x-padding">
        <ux-form
          ref="form"
          :data="formData"
          width="550px"
          :colon="true"
          :rules="rules"
          label-width="110px"
          :hideBtn="true"
        >
          <ux-form-item :label="$t('HT.apiStepTwo.protocol')" prop="protocol">
            <ux-radio v-model="formData.protocol" :options="$opt.agreement"></ux-radio>
          </ux-form-item>
          <ux-form-item :label="$t('HT.apiStepThree.path')" prop="uri">
            <ux-input
              v-model="formData.uri"
              :placeholder="$t('HT.apiStepThree.path.placeholder')"
            ></ux-input>
          </ux-form-item>
          <ux-form-item :label="$t('HT.apiStepThree.method')" prop="method">
            <ux-select
              v-model="formData.method"
              :options="$opt.httpMethod"
              @change="onchange"
            ></ux-select>
          </ux-form-item>
          <ux-form-item
            :label="$t('HT.apiStepTwo.transferType')"
            :optionText="false"
            prop="transfer_type"
          >
            <ux-select v-model="formData.transfer_type" :options="$opt.accessMode"></ux-select>
          </ux-form-item>
          <ux-form-item
            v-if="
              this.formData.method == 'POST' ||
              this.formData.method == 'PATCH' ||
              this.formData.method == 'PUT' ||
              this.formData.method == 'ANY'
            "
            :label="$t('HT.apiStepTwo.bodyType')"
            :optionText="false"
            prop="body_type"
          >
            <ux-select v-model="formData.body_type" :options="$opt.bodyList"></ux-select>
          </ux-form-item>
        </ux-form>
      </div>
    </div>
    <div class="x-border-50 x-margin-b" v-if="this.formData.transfer_type !== 'PASS_THROUGH'">
      <my-head-title :title="$t('HT.apiStepTwo.title2')"></my-head-title>
      <div class="x-padding">
        <ux-table
          class="x-table-add-style"
          ref="table"
          xborder
          :showPage="false"
          :data="formData.parameters"
          :columns="columns"
          :emptyText="$t('HT.nodata')"
          layout="total, sizes, prev, pager, next"
        ></ux-table>
        <ux-button type="primary" style="margin-top: 20px" @click="addTable">{{
          $t('HT.add')
        }}</ux-button>
      </div>
    </div>
  </div>
</template>

<script>
import addFieldInput from './addFieldInput';
export default {
  name: 'apiStepTwo',
  components: {
    addFieldInput
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          request: {
            uri: '', // 请求Path
            method: '', // 请求方法
            transfer_type: '', // 传输模式
            parameters: [], // 请求参数集合
            body_type: '', //body类型
            protocol: '', // http
            requestType: '' // 请求类型
          }
        };
      }
    }
  },
  data() {
    return {
      formData: this.data.request,
      rules: this.$rul.addApi(),
      addInputList: [],
      columns: [
        {
          label: this.$t('HT.apiStepTwo.paramsName'),
          width: 150,
          tooltip: true,
          prop: 'index',
          render: (h, params, index) => {
            return h(addFieldInput, {
              ref: `addForm${index}`,
              props: {
                columns: this.columns,
                data: this.formData.parameters[index]
              },
              on: {
                del: () => {
                  this.delTable(index);
                }
              }
            });
          }
        },
        {
          label: this.$t('HT.apiStepThree.origin'),
          prop: 'origin',
          tooltip: true,
          width: 150
        },
        {
          label: this.$t('HT.upgrade.type'),
          prop: 'type',
          tooltip: true,
          width: 150
        },
        {
          label: this.$t('HT.required'),
          prop: 'lowPressure',
          tooltip: true,
          width: 80
        },
        {
          label: this.$t('HT.default'),
          prop: 'origin',
          tooltip: true
        },
        {
          label: this.$t('HT.example'),
          prop: 'lowPressure',
          tooltip: true
        },
        {
          label: this.$t('HT.apiStepOne.remark'),
          prop: 'origin',
          tooltip: true
        },
        {
          label: this.$t('HT.operation'),
          prop: 'index',
          tooltip: true
        }
      ]
    };
  },

  created() {
    this.$set(this.formData, 'protocol', this.data.protocol);
    if (!this.formData.parameters) {
      this.formData.parameters = [];
    }
  },

  methods: {
    /**
     * 验证回调
     */
    confirm() {
      let flag = true;
      function isError(valid) {
        if (!valid) flag = false;
      }
      return new Promise((resolve) => {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            if (this.formData.transfer_type == 'PASS_THROUGH') {
              this.formData.parameters = [];
              resolve(this.formData);
            } else {
              for (let i = 0; i < this.formData.parameters.length; i++) {
                this.$refs['table'].$refs[`addForm${i}`].$refs['form'].validate((valid) =>
                  isError(valid)
                );
              }
              if (flag) {
                resolve(this.formData);
              }
            }
          }
        });
      });
    },

    /**
     * 新增入参
     */
    addTable() {
      this.formData.parameters.push({
        sort_num: this.formData.parameters.length + 1,
        required: false
      });
    },

    /**
     * 移除当前入参
     */
    delTable(index) {
      this.formData.parameters.splice(index, 1); // 移除当前入参
    },

    /**
     * 改变请求方法
     */
    onchange() {
      this.$set(this.formData, 'body_type', null);
    }
  },

  watch: {
    data: {
      handler() {
        this.formData = this.data.request;
        if (!this.formData.parameters) {
          this.formData.parameters = [];
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
.el-form {
  .create_model {
    width: 100px;
    text-align: right;
  }
  .model_work {
    width: 140px;
    text-align: right;
  }
}
</style>
